import { trans } from "./../helper/trans";
import { dimmer } from "../helper/dimmer";
import { notify } from "./../helper/notify";
import { getAssetMap } from "./../helper/getAssetMap";
import { preview } from "./../helper/preview";
import { scroll } from "./../helper/scroll";
import { parseTerms } from "./../helper/parseTerms";
import { fetchMedia } from "./../helper/fetchMedia";
import { updateCache } from "./../helper/updateCache";
import { playButton } from "./../helper/playButton";
import { metaFields, placeholder } from "../app";
import { request } from "../helper/request";
// some imports from our global scope

import { v4 as uuid } from "uuid";

let assetContainer = $("#dam_assets");
let assetMap = {}; // processed assets by category/subcategory (dupes)
let flatAssetMap = []; // assetMap as an array for filter matching
let _assets = {}; // temp object for de-duping assets
let assets = []; // de-duped asset storage for grid
let buildAssets = []; // mutable current asset set
let pageNo = 1;
let userLevel;
let perPage = window.isMobile ? 10 : 9;
let admin = false;
let user = "";

export const aircraftOrder = ["G800", "G700", "G650ER", "G650", "G600", "G500", "G550", "G450", "G400", "G280", "G350-G450", "G200", "G100-G150", "GV", "GIV", "GIII", "GII", "GI"];
// what aircraft do we care about, and in what order?

export const siteOrder = ["Appleton", "Beijing", "Brunswick", "Dallas", "Farnborough", "London", "Long Beach", "Manhattan", "Palm Beach", "Savannah", "St. Louis", "Van Nuys", "Westfield"];

window.renderContent = async _user => {
	// has either _user.gacUser OR _user.user
	user = _user;
	userLevel = user.userLevel;
	admin = userLevel.toLowerCase() === "admin" ? true : false;
	$("#media_filter").append(dimmer(2)).css("position", "relative");
	if (admin) {
		$("#update_cache_button")
			.removeClass("hidden")
			.on("click", async function (e) {
				e.preventDefault();
				const response = await updateCache(["Widen Assets Newsroom"]);
			});
	}
	try {
		const response = await fetchMedia(
			{
				terms: "usage:multimedia center",
				expand: "asset_properties,file_properties,metadata,security,thumbnails,embeds"
			},
			[],
			admin
		);

		assetMap = getAssetMap(response, metaFields);
		for (let group in assetMap) {
			for (let key in assetMap[group]) {
				assetMap[group][key].forEach(item => {
					flatAssetMap.push(item);
					// all assets, including duplicates, go in this array

					_assets[item.external_id] = item;
					// no dupes in this object
				});
			}
		}
		// _assets is now an object keyed by asset external_ids
		// (to de-dupe assetMap objects)

		for (let key in _assets) {
			assets.push(_assets[key]);
		}
		_assets = null;
		// no memory leaks, thanks

		assets = shuffle(assets);
		// randomize order for presentation

		buildAssets = assets.map(item => item);
		// buildAssets starts as a clone of assets,
		// but can be modified via filtering

		buildMediaBrowser(buildAssets, assetMap);
		// kick off initial build of media browser
	} catch (err) {
		console.error("Error fetching media:", err);
		notify(trans("There was an error retrieving media assets."), "danger");
		// update UI at mediaMsgs with error
	}
};
// end renderContent function

const shuffle = arr => {
	// adapted from
	// https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array

	let shuffledArr = arr.map(item => item);
	// let's work with a copy

	let currentIndex = shuffledArr.length,
		temporaryValue,
		randomIndex;

	// While there remain elements to shuffle...
	while (0 !== currentIndex) {
		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;

		// And swap it with the current element.
		temporaryValue = shuffledArr[currentIndex];
		shuffledArr[currentIndex] = shuffledArr[randomIndex];
		shuffledArr[randomIndex] = temporaryValue;
	}
	return shuffledArr;
};
// end shuffle function

const buildMediaBrowser = (buildAssets, assetMap) => {
	assetContainer.attr("build", isMobile ? "mobile" : "desktop");
	let filterOptions = [];
	metaFields.forEach(group => {
		let key = Object.keys(group)[0];
		filterOptions.push(`<optgroup data-key="${key}" label="${trans(group[key])}">
            ${(function () {
				let options = [];
				for (let _key in assetMap[key]) {
					options.push(_key);
				}
				if (key === "model") {
					// let's sort aircraft by as set by aircraftOrder
					// then build the option elements

					for (let i = aircraftOrder.length - 1; i > -1; i--) {
						// move through aircraftOrder from bottom up

						let target = options.find(option => option === aircraftOrder[i]);
						// find option matching this aircraft's key

						if (target) {
							options = options.filter(option => option != aircraftOrder[i]);
							// remove this option

							options.unshift(target);
							// replace this option at the head of the list
						}
					}
					// model keys are now in preferred order
				} else if (key === "sites" || key === "prodsupp") {
					// lets sort options with site names as set by siteOrder

					for (let i = siteOrder.length - 1; i > -1; i--) {
						// move through siteOrder from bottom up

						let target = options.find(option => option.indexOf(siteOrder[i]) > -1);
						if (target) {
							// make this check in case site name is removed
							// from the DAM but not the siteOrder list

							options = options.filter(option => option.indexOf(siteOrder[i]) === -1);
							// remove this site from options array

							options.unshift(target);
							// and add it back to the top of the list
						}
					}
				}
				return options.map(option => `<option value="${option}">${trans(option) ? trans(option) : option}</option>`).join("");
			})()}
            </optgroup>`);
	});
	$("#media_categories").append(filterOptions.join("")).select2({
		dropdownParent: "#filter_field",
		width: "100%",
		tags: false,
		allowClear: false
	});
	// build filter option groups and options

	setTimeout(() => {
		let arrowWrapper = $(".select2-selection__arrow");
		arrowWrapper.each(function () {
			$(this).append(`<span class="select_arrow" uk-icon="icon: chevron-down"></span>`);
		});
	}, 200);
	// add uikit chevron dropdown arrows

	$("#media_categories")
		.off("select2:opening")
		.on("select2:opening", function () {
			$(this).siblings(".select2-container").find(".select_arrow").attr("uk-icon", "icon: chevron-up");
		})
		.on("select2:closing", function () {
			$(this).siblings(".select2-container").find(".select_arrow").attr("uk-icon", "icon: chevron-down");
		});
	// opening/closing listeners to orient chevrons

	$("#clear_form_button")
		.off("click")
		.on("click", function (e) {
			e.preventDefault();
			$("#terms").val("");
			$("#media_categories").val(null).trigger("change");
			buildAssets = assets.map(item => item);
			pageNo = 1;
			updatePagination(buildAssets);
			updateGrid(assets, perPage, user);
		});
	// clear form button click handler

	$("#media_filter").find(".dimmer").remove();

	updatePagination(buildAssets);
	updateGrid(buildAssets, perPage, user);
	// put assets in grids

	let marquee;
	$(".image_name")
		.on("mouseover", function (e) {
			if (!e.target.getAttribute("marquee")) {
				const overlap = e.target.clientWidth - e.target.parentNode.clientWidth;
				if (overlap) {
					e.target.setAttribute("marquee", "active");
					let counter = 0;
					marquee = setInterval(function () {
						if (counter < overlap) {
							counter++;
							e.target.style.left = `-${counter}px`;
						}
					}, 2);
				}
			}
		})
		.on("mouseout", function (e) {
			if (e.target.getAttribute("marquee")) {
				clearInterval(marquee);
				e.target.removeAttribute("marquee");
				$(e.target).animate(
					{
						left: 0
					},
					"fast"
				);
			}
		});
	// hover marquee effect on long multimedia center names
};
// end buildMediaBrowser function

const updatePagination = buildAssets => {
	let paginationWrapper = $("#pagination_wrapper");
	let showingWrapper = $("#showing_wrapper");
	let pageList = paginationWrapper.find("ul").html("");
	let perPage = window.isMobile ? 10 : 9;
	let numPages = Math.ceil(buildAssets.length / perPage);
	if (pageNo > 1) {
		pageList.append(`<li>
                <a data-previous data-target="${pageNo - 1}"><span uk-pagination-previous></span></a>
            </li>`);
	}
	// we need a previous button if we're past page 1

	let isActive = pageNo === 1;
	pageList.append(`<li>
            <a data-target="1" class="page_link${isActive ? " uk-active" : ""}"><span class="page${isActive ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">1</span></a>
        </li>`);
	// always have page 1

	if (numPages < 11) {
		// don't need our inactive elements
		for (let i = 2; i < numPages + 1; i++) {
			isActive = pageNo === i;
			pageList.append(`<li>
                    <a data-target="${i}" class="page_link${isActive ? " uk-active" : ""}"><span class="page${isActive ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${i}</span></a>
                </li>`);
		}
	} else {
		// need at least one inactive separator

		if (pageNo < 6) {
			// don't need beginning separator

			for (let i = 2; i < 9; i++) {
				isActive = pageNo === i;
				pageList.append(`<li>
                    <a data-target="${i}" class="page_link${isActive ? " uk-active" : ""}"><span class="page${isActive ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${i}</span></a>
                </li>`);
			}
			pageList.append(` <li class="uk-disabled"><span>...</span></li>
                <li>
                    <a data-target="${numPages}" class="page_link"${pageNo === numPages ? " uk-active" : ""}"><span class="page${pageNo === numPages ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${numPages}</span></a>
                </li>`);
		} else {
			// need at least beginning separator

			pageList.append(` <li class="uk-disabled"><span>...</span></li>`);
			let remaining = numPages - pageNo;
			let lastPage = remaining > 2 ? pageNo + 3 : numPages;
			for (let i = pageNo - 2; i < lastPage; i++) {
				isActive = pageNo === i;
				pageList.append(`<li>
                        <a data-target="${i}" class="page_link${isActive ? " uk-active" : ""}"><span class="page${isActive ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${i}</span></a>
                    </li>`);
			}
			if (pageNo < numPages - 3) {
				// need second separator
				pageList.append(` <li class="uk-disabled"><span>...</span></li>`);
			}
			pageList.append(`<li>
                    <a data-target="${numPages}" class="page_link${pageNo === numPages ? " uk-active" : ""}"><span class="page${pageNo === numPages ? " active uk-flex uk-flex-center uk-flex-middle" : ""}">${numPages}</span></a>
                </li>`);
		}
	}
	if (pageNo < numPages) {
		pageList.append(`<li>
                <a data-next data-target="${pageNo + 1}"><span uk-pagination-next></span></a>
            </li>`);
	}
	// we need a next button if we're not on last page

	let startPage = buildAssets.length ? pageNo * perPage - perPage + 1 : 0;
	let endPage = pageNo * perPage > buildAssets.length ? buildAssets.length : pageNo * perPage;
	// calculate last page in showing range

	showingWrapper.html(`<span>${trans("showing")}</span> ${startPage}-${endPage} ${trans("of")} ${buildAssets.length}`);

	$("#pagination_wrapper [data-target]")
		.off("click")
		.on("click", function () {
			pageNo = parseInt($(this).attr("data-target"));
			updateGrid(buildAssets, perPage, user);
			scroll($("#media_filter"), 100);
			updatePagination(buildAssets);
		});
	// click handler for pagination
};
// end updatePagination function

const updateGrid = (buildAssets, perPage, user) => {
	let assetWrappers = assetContainer.find(".asset_wrapper").hide();
	assetWrappers.find(".play_button_overlay").remove();
	let imgTags = assetContainer.find(window.isMobile ? "#mobile_grid img" : "#desktop_grid img");
	let metaWrappers = assetContainer.find(window.isMobile ? "#mobile_grid .metadata_wrapper" : "#desktop_grid .metadata_wrapper");
	let imgIndex = 0;
	for (let i = (pageNo - 1) * perPage; i < (pageNo - 1) * perPage + perPage; i++) {
		let asset = buildAssets[i];
		if (asset) {
			let thisImg = imgTags.eq(imgIndex);
			let imgWrapper = thisImg.parents(".asset_wrapper").attr("data-type", asset.type ? asset.type : asset.video ? "Video" : asset.document ? "PDF" : "Image");
			thisImg
				.attr({
					"data-index": i % perPage,
					"data-src": asset.thumb,
					"data-id": asset.external_id,
					alt: asset.name,
					"data-locator-field": asset.locator.field,
					"data-locator-value": asset.locator.value
				})
				.parents(".asset_wrapper")
				.show();
			let type = imgWrapper.attr("data-type");
			if (type === "Video") {
				imgWrapper
					.find(".media_image_wrapper")
					.css("position", "relative")
					.append(playButton(window.isMobile ? 40 : 60));
			}
			thisImg.css("cursor", "zoom-in").on("click", function () {
				preview(
					$(this).parents(".asset_wrapper").attr("data-type").toLowerCase(),
					assetMap[$(this).attr("data-locator-field")][$(this).attr("data-locator-value")].find(item => item.external_id === $(this).attr("data-id")),
					null,
					null,
					imgTags,
					parseInt($(this).attr("data-index"))
				);
			});
			metaWrappers.eq(imgIndex).find(".image_name").html(`${asset.name}`);
			if (userLevel && userLevel != "guest") {
				thisImg
					.parents(".asset_wrapper")
					.find(".link_wrapper")
					.html(`<a data-uuid="${asset.uuid}" class="underline" ${asset.url ? `href="${asset.url}"` : ""} target="_blank">${asset.url ? trans("download") : trans("Download unavailable")}</a>`)
					.off("click")
					.on("click", async function () {
						let download = JSON.parse(JSON.stringify(buildAssets.find(item => item.uuid === $(this).find("[data-uuid]").attr("data-uuid"))));
						delete download.cart_thumb;
						delete download.src;
						try {
							const _user = JSON.parse(JSON.stringify(user.user ? user.user : user.gacUser));
							if (_user.token) {
								delete _user.token;
							}
							// don't store token in db
							const item = {
								type: "download",
								id: uuid(),
								user: _user,
								item: download,
								time: Date.now(),
								ttl: Date.now() + 1000 * 60 * 60 * 24 * 365 * 5
							};
							await request({
								reqId: "e7afce7f-0c86-4aa5-91b7-fd8fe5df2e90",
								data: item
							});
						} catch (err) {
							console.error(`Error saving download record: ${err}`);
							return;
						}
					});
			} else {
				let inCart = Object.keys(window.cart).includes(asset.external_id);
				// if asset is in cart, we're not adding, but removing

				const imageNameWrapper = thisImg.parents(".asset_wrapper").find(".image_name_wrapper");
				if (inCart) {
					imageNameWrapper.addClass("incart");
				} else {
					imageNameWrapper.removeClass("incart");
				}
				thisImg
					.parents(".asset_wrapper")
					.find(".link_wrapper")
					.addClass(inCart ? "incart" : "")
					.html(`<span ${inCart ? "inCart" : ""} data-locator-field="${asset.locator.field}" data-locator-value="${asset.locator.value}" data-id="${asset.external_id}" class="add_link underline" tabindex="0">${inCart ? trans("Remove From Collection") : trans("Add To Collection")}</span>`)
					.find(".add_link")
					.off("click")
					// add add/remove links to assets

					.on("click", function () {
						let asset = assetMap[$(this).attr("data-locator-field")][$(this).attr("data-locator-value")].find(asset => asset.external_id === $(this).attr("data-id"));
						if ($(this).is("[inCart]")) {
							delete window.cart[asset.external_id];
							$(this).removeAttr("inCart");
							$(this).text(trans("Add To Collection"));
							imageNameWrapper.removeClass("incart");
						} else {
							window.cart[asset.external_id] = {
								name: asset.name,
								thumb: asset.cart_thumb ? asset.cart_thumb : placeholder,
								locator: asset.locator,
								size: asset.size ? asset.size : trans("Unknown"),
								uuid: asset.uuid,
								type: asset.type
							};
							$(this).attr("inCart", "");
							imageNameWrapper.addClass("incart");
							$(this).text(trans("Remove From Collection"));
						}
						updateCart();
						// update cart counter and local storage
					});
				// add selection to cart click handler
			}
			imgIndex++;
		}
	}
};
// end updateGrid function

$("#media_form #submit_button").on("click", function (e) {
	e.preventDefault();
	let categoryObj = $("#media_categories").select2("data")[0];
	let value = false;
	let field = false;
	if (categoryObj.id) {
		// with select2, "id" prop is
		// the <select> element's value

		value = categoryObj.id.toLowerCase();
		field = $(categoryObj.element).parents("optgroup").attr("data-key").toLowerCase();
	}
	const termsVal = $("#terms").val();
	let terms = termsVal ? parseTerms(termsVal.toLowerCase()) : [];
	let termsMatch = false;
	let filterMatch = false;
	buildAssets = flatAssetMap
		.filter(item => {
			if (value && field) {
				filterMatch = item.locator.field.toLowerCase() === field && item.locator.value.toLowerCase() === value;
			} else {
				filterMatch = true;
			}
			if (terms.length) {
				let matchCount = 0;
				terms.forEach(term => {
					if ((item.name && item.name.toLowerCase().indexOf(term) > -1) || (item.filename && item.filename.toLowerCase().indexOf(term) > -1) || (item.locator && item.locator.field.toLowerCase().indexOf(term) > -1) || (item.locator && item.locator.value.toLowerCase().indexOf(term) > -1) || (item.type && item.type.toLowerCase() === term)) {
						matchCount++;
					}
					// each time a term matches criteria,
					// (string is in asset name or category/subcategory),
					// match count is incremented
				});
				termsMatch = matchCount === terms.length;
				// if matchcount is same as terms length,
				// every term was matched, so termsMatch is true
			} else {
				termsMatch = true;
			}
			return filterMatch && termsMatch;
			// returning 'true' adds asset to filter results
		})
		.reduce((unique, item) => (unique.find(_item => _item.external_id === item.external_id) ? unique : [...unique, item]), []);
	// we look for term matches in flatAssetMap to
	// have the widest possible source,
	// but flatAssetMap also has duplicate items
	// so we reduce the result set with a function that
	// throws out any entries with the same external_id.
	// It works by passing in the result accumulator array (as "unique")
	// and returning it unchanged if the current item's external id is found
	// in it, or adding the item if not

	pageNo = 1;
	updatePagination(buildAssets);
	updateGrid(buildAssets, perPage);
});
// filter submit button click handler

$(window).on("resize", function () {
	perPage = window.isMobile ? 10 : 9;
	let build = assetContainer.attr("build");
	build = build === "undefined" ? (window.isMobile ? "mobile" : "desktop") : build;
	if (buildAssets.length && ((window.isMobile && build != "mobile") || (!window.isMobile && build != "desktop"))) {
		buildMediaBrowser(buildAssets, assetMap);
	}
});
// resize listener to rebuild media gallery on
// mobile <-> non-mobile change
